import * as AppConstants from 'app/AppConstants';

const initialState = () => ({
  enabled: new Set(),
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.CARD__SETTINGS_LOADED: {
      return {
        ...state,
        enabled: new Set(action.payload.settings),
      };
    }
    default:
      return state;
  }
};
